import { useEffect, useState } from "react";
import {staticObservatoryData} from "./../../staticdata.js";

const getPathAndFormattedSiblingBySourceId = (sourceId, data, path = []) => {
  if (Array.isArray(data)) {
    for (const item of data) {
      if (item?.source_id === sourceId) {
        const { source_id, ...siblings } = item;
        const [key, value] = Object.entries(siblings)[0] || [];
        return [path.at(-1), `${key}: ${value}`];
      }
    }
  } else if (typeof data === "object" && data !== null) {
    for (const [key, value] of Object.entries(data)) {
      const result = getPathAndFormattedSiblingBySourceId(sourceId, value, [...path, key]);
      if (result) return result;
    }
  }
  return null;
};

export function HelioviewerMissionInfoBox({
  mission,
  defaultSourceId,
  onChange,
}) {
  const [categoryKey, setCategoryKey] = useState("");
  const [sourceId, setSourceId] = useState(defaultSourceId || "");
  const [selectionInfo, setSelectionInfo] = useState(null);
  const [editing, setEditing] = useState(false);

  const categoryKeys = Object.keys(staticObservatoryData[mission] || {});
  const currentOptions = categoryKey ? staticObservatoryData[mission][categoryKey] : [];

  useEffect(() => {
    if (sourceId) {
      const info = getPathAndFormattedSiblingBySourceId(sourceId, staticObservatoryData);
      setSelectionInfo(info);
    }
  }, [sourceId]);

  const handleChange = (e) => {
    setEditing(false);
    setSourceId(e.target.value)
    onChange?.(e.target.value);
  };

  return (
    <div className="helioviewerInfoBox helioviewerRecursiveDropdown">
      {selectionInfo ? (<div>
        <h4 className="helioviewerInfoTextTitle" ><strong>{selectionInfo[0].split(/_/g,)[0]}</strong></h4>
        <div><strong>{selectionInfo[0].split(/_/g,)[1]}</strong></div>
        <h4 className="helioviewerInfoTextTitle" ><strong>{selectionInfo[1].split(":")[0]}</strong></h4>
        <div><strong>{selectionInfo[1].split(":")[1]}</strong></div>
      </div>) : (
        <strong>No selection made yet.</strong>
      )}

      {!editing && (
        <div className="helioviewerInfoTextBody">
          <button
            onClick={() => setEditing(true)}
            className="helioviewerModalButtonWide"
          >
            Edit
          </button>
        </div>
      )}

      {editing && (
        <>
          <label>Select Category:</label>
          <select onChange={(e) => {
            setCategoryKey(e.target.value);
            setSourceId("");
            setSelectionInfo(null);
          }} value={categoryKey} className="helioviewerDrpDwnSelect helioviewerInputExtraWide">
            <option value="">-- Select --</option>
            {categoryKeys.map(key => (
              <option key={key} value={key}>{key.replace(/_/g, " ")}</option>
            ))}
          </select>

          {categoryKey && (
            <>
              <label>Select Option:</label>
              <select onChange={handleChange} value={sourceId} className="helioviewerDrpDwnSelect">
                <option value="">-- Select --</option>
                {currentOptions.map((item) => {
                  const { source_id, ...rest } = item;
                  const [key, value] = Object.entries(rest)[0] || [];
                  const label = `${key}: ${value}`;
                  return (
                    <option key={source_id} value={source_id}>
                      {label}
                    </option>
                  );
                })}
              </select>
            </>
          )}
        </>
      )}
    </div>
  );
}
